
$(function() {
    $('#dropdownGiftCardPriceX').on('change', function () {
        const $self = $(this);
        $('#textboxGiftCardPriceX').val($self.val());
    });

    $('#textboxGiftCardPriceX').on('keyup change', function () {
        $('#dropdownGiftCardPriceX').val(null);
    });

});
